import React, { ReactElement, ReactNode, useEffect } from 'react';
import { Wrapper, DropdownMenuList, DropdownMenuPopover } from './styles';

export interface DropdownProps {
  isOpen: boolean;
  closeDrawer(): void;
  triggerElement: ReactNode;
  menuItems: ReactElement[];
  id?: string;
}

export const Dropdown = ({
  closeDrawer,
  isOpen,
  triggerElement,
  menuItems,
  id = 'dropdown-menu',
}: DropdownProps) => {
  const handleKeyboardClose = (event: KeyboardEvent): void => {
    const escKeyPressed = event.key === 'Esc' || event.key === 'Escape';
    if (isOpen && escKeyPressed) {
      closeDrawer();
    }

    return;
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyboardClose, {
      capture: true,
    });

    return () => {
      document.removeEventListener('keydown', handleKeyboardClose, {
        capture: true,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <Wrapper>
      {triggerElement}
      <DropdownMenuPopover isOpen={isOpen} aria-hidden={!isOpen} id={id}>
        <DropdownMenuList role="menu">
          {menuItems.map((item, i) => (
            <li role="menuitem" key={i}>
              {React.cloneElement(item, {
                ...item.props,
                menuIsOpen: isOpen,
              })}
            </li>
          ))}
        </DropdownMenuList>
      </DropdownMenuPopover>
    </Wrapper>
  );
};
